if (!customElements.get("featured-filters")) {
  class FeaturedFilter extends HTMLElement {
    constructor() {
      super();

      const triggers = this.querySelectorAll(".tab");

      function clearActiveTab(f) {
        f.forEach((t) => t.classList.remove("active"));
      }

      triggers.forEach((t) => {
        t.addEventListener("click", (e) => {
          clearActiveTab(triggers);
          t.classList.add("active");

          this.setAttribute("data-active", t.innerText.trim());
        });
      });
    }

    static get observedAttributes() {
      return ["data-active"];
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === "data-active" && oldValue !== newValue) {
        this.filterByCat(newValue);
      }
    }

    filterByCat(d) {
      const section = this.closest(".card-carousel__inner");

      if (!section) return;

      const container = section.querySelector(".has-filters");
      if (!container) return;

      if (!container._allSlides) {
        container._allSlides = Array.from(container.querySelectorAll(".filter_item"));
      }

      const allSlides = container._allSlides;

      container.innerHTML = "";

      const showAll = ["Alle", "All", "All Articles", "All Products", "Alle Gerichte", "All meals", "Tous les plats"].includes(d);
      
      allSlides.forEach((c) => {
        c.classList.remove("visually-hidden"); 
        
        if (showAll || (c.dataset.cats && (c.dataset.cats.includes(d) || c.dataset.cats === d))) {
          container.appendChild(c);
        }
      });

      const emblaElement = section.querySelector("embla-component");
      
      if (emblaElement && emblaElement.emblaApi) {
        emblaElement.emblaApi.reInit();
      }
    }
  }

  customElements.define("featured-filters", FeaturedFilter);
}